import { ImageOutlined } from '@mui/icons-material';
import { GridColDef } from '@mui/x-data-grid';
import { Image } from '@sahinyazilim/sahinyazilim-components';
import { getCdnImageUrl } from 'common/utils/image';

export const fileListColumns: GridColDef[] = [
  {
    field: 'path',
    headerName: (<ImageOutlined />) as any,
    headerAlign: 'center',
    width: 70,
    renderCell: (params) => (
      <Image
        src={`${getCdnImageUrl(params.value || params.row.path)}`}
        alt="Önizleme"
        width={50}
        aspectRatio="1/1"
      />
    ),
  },
  {
    field: 'name',
    headerName: 'Dosya Adı',
    width: 330,
  },
  {
    field: 'size',
    headerName: 'Boyut',
    align: 'center',
    headerAlign: 'center',
    width: 150,
    valueFormatter: (params) => `${(params.value / 1024).toFixed(2)} KB`,
  },
  {
    field: 'createdAt',
    headerName: 'Yükleme Tarihi',
    align: 'center',
    headerAlign: 'center',
    width: 150,
    valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
  },

  {
    field: 'ext',
    headerName: 'Uzantı',
    align: 'center',
    headerAlign: 'center',
    width: 150,
  },

  {
    field: 'mimeType',
    headerName: 'Tür',
    align: 'center',
    headerAlign: 'center',
    width: 150,
    valueFormatter: (params) => params.value || '-',
  },
];
